export default __webpack_public_path__ + "static/media/Front-Sheyaaka-Production-House-1.526adf89.jpg";